export type { AreaMasterProps } from './area-master';
export * from './area-master.routes';

export { default as AreaMaster, default } from './area-master';
